import { logDebug, type WebSocketMessage } from './types';

interface MessageSink {
  handleMessage(message: WebSocketMessage): boolean;
}

/**
 * Routes one parsed server message to the store that owns it (task events
 * first, then user-level events). Returns false for unknown types.
 */
export function routeWebSocketMessage(
  message: WebSocketMessage,
  stores: { tasks: MessageSink; user: MessageSink }
): boolean {
  switch (message.type) {
    case 'pong':
      // Heartbeat response - no action needed
      return true;
    case 'connected':
      logDebug('[WebSocket] Connection confirmed, user_id:', message.payload?.user_id);
      return true;
    default:
      if (stores.tasks.handleMessage(message)) return true;
      if (stores.user.handleMessage(message)) return true;
      logDebug('[WebSocket] Unknown message type:', message.type);
      return false;
  }
}
